const JobTag = ({ text }) => {
    return (
      <span className="px-4 py-1 text-sm font-semibold rounded-[80px] bg-indigo-100 text-indigo-600">
        {text}
      </span>
    );
  };
  
  export default JobTag;
  